const ITEMS = [
  "Restructuration",
  "M&A",
  "Cash Burn Diagnostic",
  "Évaluation Multicritère",
  "Pré-pack Judiciaire",
  "Business Plan de Continuation",
  "Pilotage de Crise",
  "Advisory Boutique",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-slate-100 border-y border-slate-200 py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 pr-8 font-mono text-xs uppercase tracking-[0.25em] text-slate-500"
          >
            {item}
            <span className="w-1 h-1 rounded-full bg-slate-400" />
          </span>
        ))}
      </div>
    </div>
  );
}
